module.exports = {"button.close":"Zavřít"}